module.exports = __webpack_public_path__ + "img/staff-photo-3.bb7f44d.webp";